import React, {Component} from 'react'
import axios from "axios";
import ProgressCount from "../../components/ProgressCount/ProgressCount";
import StatTableContainer from "../StatTableContainer/StatTableContainer";
import {Link} from "react-router-dom";
import Box from "@material-ui/core/Box";
import {formatNumber} from "../../shared/Utility";

class StatContainer extends Component {

  state = {
    localStats: [],
    worldStats: [],
    localNewCases: 0,
    localNewDeaths: 0,
    todayCases: 0,
    todayDeaths: 0,
    error: false
  };

  roundPercentage = percentage => percentage.toFixed(2);

  componentDidMount = () => {
    axios.get('https://corona.lmao.ninja/v2/countries/LK')
    // axios.get('https://hpb.health.gov.lk/api/get-current-statistical')
      .then(response => {

        const localTotalCases = response.data.cases;
        const localDeaths = response.data.deaths;
        const localRecovered = response.data.recovered;
        const localActiveCases = response.data.active;
        const localNewCases = response.data.todayCases;
        const localNewDeaths = response.data.todayDeaths;

        const localStats = [
          {title: 'Total Cases', count: localTotalCases, progressBarClass: 'info'},
          {
            title: 'Deaths', count: localDeaths, progressBarClass: 'danger',
            ratioPc: this.roundPercentage(localDeaths / localTotalCases * 100)
          },
          {
            title: 'Recovered', count: localRecovered, progressBarClass: 'success',
            ratioPc: this.roundPercentage(localRecovered / localTotalCases * 100)
          },
          {
            title: 'Active Cases', count: localActiveCases, progressBarClass: 'warning',
            ratioPc: this.roundPercentage(localActiveCases / localTotalCases * 100)
            // },
            // {
            //   title: 'New Cases', count: localNewCases,
            //   ratioPc: this.roundPercentage(localNewCases / localTotalCases * 100)
            // },          {
            //   title: 'New Deaths', count: localNewDeaths,
            //   ratioPc: this.roundPercentage(localNewDeaths / localDeaths * 100)
          }
        ];
        /*
                const localStats = [
                  {localTotalCases:   {count: response.data.data.local_total_cases}},
                  {localDeaths:       {count: response.data.data.local_deaths}},
                  {localRecovered:    {count: response.data.data.local_recovered}},
                  {localActiveCases:  {count: response.data.data.local_active_cases}},
                ];
        */

        this.setState({localStats: localStats});
        this.setState({localNewCases: localNewCases});
        this.setState({localNewDeaths: localNewDeaths});
      })
      .catch(error => {
        this.setState({error: true})
      });

    axios.get('https://corona.lmao.ninja/v2/all')
      .then(response => {
        const totalCases = response.data.cases;
        const deaths = response.data.deaths;
        const recovered = response.data.recovered;
        const activeCases = response.data.active;
        const todayCases = response.data.todayCases;
        const todayDeaths = response.data.todayDeaths;

        const worldStats = [
          {title: 'Total Cases', count: totalCases, progressBarClass: 'info'},
          {
            title: 'Deaths', count: deaths, progressBarClass: 'danger',
            ratioPc: this.roundPercentage(deaths / totalCases * 100)
          },
          {
            title: 'Recovered', count: recovered, progressBarClass: 'success',
            ratioPc: this.roundPercentage(recovered / totalCases * 100)
          },
          {
            title: 'Active Cases', count: activeCases, progressBarClass: 'warning',
            ratioPc: this.roundPercentage(activeCases / totalCases * 100)
          }];

        this.setState({worldStats: worldStats});
        this.setState({todayCases: todayCases});
        this.setState({todayDeaths: todayDeaths});
      })
      .catch(error => {
        this.setState({error: true})
      });
  };

  render() {

    if (!this.state.error) {
      // TODO: handle the error
    }

    const localStats = this.state.localStats.map(stats => {
        return <ProgressCount currentStats={stats} key={stats.title}/>
      }
    );

    const worldStats = this.state.worldStats.map(stats => {
        return <ProgressCount currentStats={stats} key={stats.title}/>
      }
    );

    const badgeStyles = {
      borderRadius: '25px', padding: '5px 17px', background: '#fff', color: '#000'
    };

    return (
      <section>
        <div className="section-body">
          <div className="row">
            <div className="col-sm-6">
              <div className="card ">
                <div className="card-head">
                  <header>Sri Lanka Update</header>
                </div>
                <div className="card-body">
                  {localStats}
                  <div className="row">
                    <div className="col-md-6">
                      <Box bgcolor="text.disabled" color="background.paper" p={2}>
                        <strong style={badgeStyles}>{this.state.localNewCases}</strong>&nbsp;&nbsp;&nbsp;Today Cases
                      </Box>
                    </div>
                    <div className="col-md-6">
                      <Box bgcolor="text.secondary" color="background.paper" p={2}>
                        <strong style={badgeStyles}>{this.state.localNewDeaths}</strong>&nbsp;&nbsp;&nbsp;Today Deaths
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="card ">
                <div className="card-head">
                  <header>World Live Update</header>
                </div>
                <div className="card-body">
                  {worldStats}
                  <div className="row">
                    <div className="col-lg-6">
                      <Box bgcolor="text.disabled" color="background.paper" p={2}>
                        <strong style={badgeStyles}>{formatNumber(this.state.todayCases)}</strong>&nbsp;&nbsp;&nbsp;Today Cases
                      </Box>
                    </div>
                    <div className="col-lg-6">
                      <Box bgcolor="text.secondary" color="background.paper" p={2}>
                        <strong style={badgeStyles}>{formatNumber(this.state.todayDeaths)}</strong>&nbsp;&nbsp;&nbsp;Today Deaths
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card ">
              <div className="card-head">
                <header>Confirmed Cases and Deaths by Country, Territory, or Conveyance</header>
              </div>
              <div className="card-body">
                {/*<ErrorBoundary>*/}
                <StatTableContainer/>
                {/*</ErrorBoundary>*/}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <Link to='/groceries'>
                  <button type="button" className="btn btn-primary btn-block">
                  <span className="pull-left">
                        <i className="fa fa-shopping-cart"/>
                  </span>Find Groceries
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <Link to='/pharmacies'>
                  <button type="button" className="btn btn-primary btn-block">
                    <span className="pull-left">
                        <i className="fa fa-heartbeat"/>
                    </span>Find a nearby Pharmacy
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default StatContainer;
